import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../../hooks/useAnalytics';
import { logger } from '../../lib/logger';

export const AnalyticsTracker: React.FC = () => {
  const location = useLocation();
  const analytics = useAnalytics();

  useEffect(() => {
    // Track page view on route change
    analytics.trackPageView(location.pathname);

    logger.debug('Page view tracked by AnalyticsTracker', {
      category: 'Analytics',
      data: {
        path: location.pathname,
        title: document.title,
        timestamp: new Date().toISOString()
      }
    });
  }, [location.pathname, analytics]);

  return null;
};

export default AnalyticsTracker;